import languageData from './data/language.json';
import historyData from './data/history.json';
import lawData from './data/law.json';
import { IQuestion, ITest } from './data/interfaces';
import Test from './domain/Test';

export default class TestProvider {
  test: ITest;

  language: IQuestion[];

  history: IQuestion[];

  law: IQuestion[];

  constructor() {
    this.language = languageData as IQuestion[];
    this.history = historyData as IQuestion[];
    this.law = lawData as IQuestion[];

    this.test = new Test();
  }

  getLanguage() {
    return this.language;
  }

  getHistory() {
    return this.history;
  }

  getLaw() {
    return this.law;
  }

  simulation() {
    const tempLanguage = this.clone(this.language);
    this.test.language = tempLanguage
      .sort(() => Math.random() - Math.random())
      .slice(0, 10);

    const tempHistory = this.clone(this.history);
    this.test.history = tempHistory
      .sort(() => Math.random() - Math.random())
      .slice(0, 10);

    const tempLaw = this.clone(this.law);
    this.test.law = tempLaw
      .sort(() => Math.random() - Math.random())
      .slice(0, 10);

    return this.test;
  }

  clone(object: IQuestion[]): IQuestion[] {
    const stringified = JSON.stringify(object);
    return JSON.parse(stringified) as IQuestion[];
  }
}
